import React from 'react';
import NoActiveSearchesSplash from 'v2/common/NoActiveSearchesSplash/NoActiveSearchesSplash';

const NoSearchesMessage = () => {
  return (
    <div className="mt-n4 container-xl fix-bg-images">
      <NoActiveSearchesSplash />
    </div>
  );
};

export default NoSearchesMessage;
